import $ from 'jquery';
import axios from "axios";

$(function() {

    initPlayVideo();

});

function initPlayVideo() {

    $('.play-video').unbind('click');
    $('.play-video').on('click', function(e) {

        //console.log('play-video click');

        // Remove any existing video popups
        closeVideoPopup();

        let videoId = $(this).attr('data-video-id');
        if (!videoId) { return; }

        // Stop click event bubbling
        e.stopPropagation();
        e.preventDefault();

        // Video options: controls=0&amp;modestbranding=1&amp;rel=0&amp;loop=1&amp;autoplay=1&amp;mute=1

        // Build the video popup and append it to the body ...
        $('body').append('<div id="video-popup">' +
            '<iframe src="https://www.youtube-nocookie.com/embed/' + videoId + '?controls=0&amp;modestbranding=1&amp;rel=0&amp;loop=1&amp;autoplay=1"\n' +
            '   title="YouTube video player" frameborder="0"\n' +
            '   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"\n' +
            '   referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>\n' +
            '</iframe>' +
            '<span id="close-video-popup" class="fa-stack">\n' +
            '    <i class="fa-solid fa-circle fa-stack-1x background"></i>\n' +
            '    <i class="fa-regular fa-circle-xmark fa-stack-1x foreground" onclick="closeVideoPopup()"></i>\n' +
            '</span>' +
            '</div>');

    });

}

window.closeVideoPopup = function() {

    if ($('#video-popup').length) {
        $('#video-popup').fadeOut(400, function() {
            $('#video-popup').remove();
        });
    }

}

